import React, { useContext } from 'react';
import {
  ActionIcon,
  ColorInput,
  ColorSwatch,
  Divider,
  Menu
} from '@mantine/core';
import PropTypes from 'prop-types';
import { Palette } from 'tabler-icons-react';
import AppFlexbox from '../../common/AppFlexbox';
import AppMenu from '../../common/AppMenu';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';

const WebstoreColorSchemeEditInput = ({ label, value, onChange }) => {
  const { state } = useContext(StoreContext);
  const ecomStore = state.ecomStoreSetupSummary.value?.ecomStore;

  return (
    <AppStack style={{ gap: 0 }}>
      <AppText style={{ fontSize: 14, color: '#000', fontWeight: 500 }}>
        {label}
      </AppText>
      <AppFlexbox
        style={{
          gap: 5,
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <ColorInput onChange={(v) => onChange(v)} value={value} />

        {ecomStore && (
          <AppMenu
            control={
              <ActionIcon color="dark" onClick={() => {}} variant="subtle">
                <Palette size={22} />
              </ActionIcon>
            }
            styles={{ dropdown: { padding: 0 } }}
          >
            <AppStack style={{ gap: 0 }}>
              <AppStack style={{ gap: 0, padding: '8px 16px' }}>
                <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                  Store branding
                </AppText>
              </AppStack>
              <Menu.Divider />
              <Menu.Item
                leftSection={
                  <ColorSwatch color={ecomStore.primaryColor} size={14} />
                }
                onClick={() => onChange(ecomStore.primaryColor)}
              >
                Primary color
              </Menu.Item>
              <Menu.Item
                leftSection={
                  <ColorSwatch
                    color={ecomStore.primaryContrastColor}
                    size={14}
                  />
                }
                onClick={() => onChange(ecomStore.primaryContrastColor)}
              >
                Primary Contrast
              </Menu.Item>

              <Divider />

              <Menu.Item
                leftSection={
                  <ColorSwatch color={ecomStore.secondaryColor} size={14} />
                }
                onClick={() => onChange(ecomStore.secondaryColor)}
              >
                Secondary color
              </Menu.Item>

              {ecomStore.secondaryAltColor && (
                <Menu.Item
                  leftSection={
                    <ColorSwatch
                      color={ecomStore.secondaryAltColor}
                      size={14}
                    />
                  }
                  onClick={() => onChange(ecomStore.secondaryAltColor)}
                >
                  Secondary alt color
                </Menu.Item>
              )}

              <Menu.Item
                leftSection={
                  <ColorSwatch
                    color={ecomStore.secondaryContrastColor}
                    size={14}
                  />
                }
                onClick={() => onChange(ecomStore.secondaryContrastColor)}
              >
                Secondary Contrast
              </Menu.Item>
            </AppStack>
          </AppMenu>
        )}
      </AppFlexbox>
    </AppStack>
  );
};

WebstoreColorSchemeEditInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};

export default WebstoreColorSchemeEditInput;
